const device = {
  smallMobile: 'screen and (max-width: 324px)',
  mobile: 'screen and (max-width: 767px)',
  tablet: 'screen and (max-width: 1024px)',
  desktop: 'screen and (min-width: 1025px)',
  monitor: 'screen and (min-width: 1600px)',
};

export default device;
